module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marg-20-top weekplan"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "marg-20-bottom"
  }, [_vm._v(_vm._s(_vm.$t('calendars.week_plan_and_note.week_plan')))]), _vm._v(" "), (_vm.weekNote !== undefined && _vm.weekNote.length) ? _c('div', {
    staticClass: "week_note"
  }, [_c('div', {
    staticClass: "week_note__content",
    domProps: {
      "innerHTML": _vm._s(_vm.weekNoteWithLineBreaks)
    }
  })]) : _vm._e(), _vm._v(" "), _c('ul', [_vm._l((_vm.eventsWithNotes), function(day) {
    return [(day.lessons.length !== 0) ? _c('li', {
      staticClass: "day_change"
    }, [_c('div', {
      staticClass: "day_change_header"
    }, [_c('h3', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.createLocaleDate(day.date))))])]), _vm._v(" "), _c('div', {
      staticClass: "grid grid grid-responsive"
    }, [_c('div', {
      staticClass: "col-2-12 box-size"
    }, [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.subject')))])]), _vm._v(" "), _c('div', {
      staticClass: "col-10-12"
    }, [_c('div', {
      staticClass: "col-1-3"
    }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.learning_goal')))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-1-3"
    }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.content')) + " ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-1-3"
    }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.pupil_preparation')))])])])])]), _vm._v(" "), _vm._l((day.lessons), function(event) {
      return [_c('d-week-plan-lesson', {
        attrs: {
          "event": event,
          "date": _vm.date
        }
      })]
    })], 2) : _vm._e()]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42c7094d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Desktop/weekplan/WeekPlan.vue
// module id = 1549
// module chunks = 1